const stressTicks = Array.from({ length: 11 }, (_, index) => index);
const sliderThumbSize = 44;

function getStressSummary(stressBefore, stressAfter) {
  if (stressBefore === 0) {
    return {
      label: "Stress Reduction",
      percentage: "N/A",
      title: "No comparison available",
      copy: "Set a value above zero for before therapy to compare your progress.",
    };
  }

  const percentage = ((stressBefore - stressAfter) / stressBefore) * 100;

  if (percentage > 0) {
    return {
      label: "Stress Reduction",
      percentage: `${Math.floor(Math.abs(percentage))}%`,
      title: "That’s a great improvement!",
      copy: "You’re healing, inside out.",
    };
  }

  if (percentage < 0) {
    return {
      label: "Stress Increase",
      percentage: `${Math.floor(Math.abs(percentage))}%`,
      title: "Stress increased after therapy",
      copy: "Thank you for sharing. Your care team can use this feedback supportively.",
    };
  }

  return {
    label: "Stress Reduction",
    percentage: "0%",
    title: "No change in stress level",
    copy: "Thank you for sharing how you feel.",
  };
}

function StressSlider({ id, label, name, value, tone, onChange }) {
  const ratio = value / 10;
  const progress = `${ratio * 100}%`;
  const bubbleCorrection = (0.5 - ratio) * sliderThumbSize;

  return (
    <section className="stress-scale" aria-labelledby={`${id}-title`}>
      <h2 id={`${id}-title`}>{label}</h2>
      <div className="stress-scale__card">
        <div className="stress-scale__ticks" aria-hidden="true">
          {stressTicks.map((tick) => (
            <span key={tick}>{tick}</span>
          ))}
        </div>
        <div className="stress-range-wrap">
          <input
            id={id}
            className="stress-range"
            name={name}
            type="range"
            min="0"
            max="10"
            step="1"
            value={value}
            aria-labelledby={`${id}-title`}
            aria-valuetext={`${value} out of 10`}
            style={{ "--stress-progress": progress }}
            onChange={(event) => onChange(Number(event.target.value))}
          />
          <output
            className={`stress-range__bubble stress-range__bubble--${tone}`}
            htmlFor={id}
            style={{
              left: `calc(${progress} + ${bubbleCorrection}px)`,
            }}
            aria-hidden="true"
          >
            {value}
          </output>
        </div>
      </div>
    </section>
  );
}

const ScreenFour = ({ stressBefore, stressAfter, onStressChange }) => {
  const summary = getStressSummary(stressBefore, stressAfter);

  return (
    <section className="screen-four" aria-labelledby="screen-four-title">
      <h1 className="visually-hidden" id="screen-four-title">
        Stress Level — Before and After Therapy
      </h1>

      <aside className="screen-four__intro left-side" aria-hidden="true">
        <div className="screen-four__intro-title">
          <strong>Stress Level</strong>
          <span>Before &amp; After Therapy</span>
        </div>
        <img
          className="screen-four__intro-divider"
          src="/assets/screen4-assets/line.webp"
          alt=""
        />
        <p>Personalized Care. Holistic Healing.</p>
      </aside>

      <div className="content-side">
        <div className="screen-four__main main-content">
        <StressSlider
          id="stress-before"
          label="Before Therapy"
          name="stress_before"
          value={stressBefore}
          tone="red"
          onChange={(value) => onStressChange("stressBefore", value)}
        />

        <StressSlider
          id="stress-after"
          label="After Therapy"
          name="stress_after"
          value={stressAfter}
          tone="green"
          onChange={(value) => onStressChange("stressAfter", value)}
        />

        <section className="stress-summary" aria-label="Stress reduction result">
          <div className="stress-summary__score">
            <img
              src="/assets/screen4-assets/Green_Ayurveda.webp"
              alt=""
              aria-hidden="true"
            />
            <div>
              <span>{summary.label}</span>
              <strong aria-live="polite">{summary.percentage}</strong>
            </div>
          </div>
          <div className="stress-summary__copy">
            <h2>{summary.title}</h2>
            <p>{summary.copy}</p>
          </div>
          <img
            className="stress-summary__leaf"
            src="/assets/screen4-assets/leaf.webp"
            alt=""
            aria-hidden="true"
          />
        </section>

        <section
          className="stress-encouragement"
          aria-label="You are doing incredibly well."
        >
          <div className="stress-encouragement__icon" aria-hidden="true">
            <svg viewBox="0 0 64 44">
              <g
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <path d="M32 36C21 29 18 18 25 7c5 4 7 11 7 29Z" />
                <path d="M32 36c11-7 14-18 7-29-5 4-7 11-7 29Z" />
                <path d="M30 36C17 34 10 25 11 16c9 1 15 8 19 20Z" />
                <path d="M34 36c13-2 20-11 19-20-9 1-15 8-19 20Z" />
              </g>
            </svg>
          </div>
          <div>
            <strong>You are doing incredibly well.</strong>
            <span>Keep going, your body and mind are healing together.</span>
          </div>
          <img
            className="stress-encouragement__leaf"
            src="/assets/screen4-assets/leaf.webp"
            alt=""
            aria-hidden="true"
          />
        </section>
        </div>
      </div>
    </section>
  );
}

export default ScreenFour;
